import React from 'react';
import { Card, CardBody } from 'reactstrap';
import StarRatings from "react-star-ratings";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { reviews } from '../../constants/reviews';
import { isMobile } from 'react-device-detect';
import { IReviews } from '../../Interfaces/constants';

const getInitials = (name: string) => {
  var letters = name.split(' '),
      initials = letters[0].substring(0, 1).toUpperCase();
  
  if (letters.length > 1) {
      initials += letters[letters.length - 1].substring(0, 1).toUpperCase();
  }
  return initials;
};

let settings = {
  dots: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 5000,
  speed: 1000,
  slidesToShow: 3,
  slidesToScroll: 1,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 2
      }
    },
  ]
};

const ReviewsSection = () => {
  return <section className="section reviews-section">
    <div className="text-center mb-5">
      <div className="small-title">Reviews</div>
      <h4 className='reviews-title'>What our partners say about us</h4>
      {isMobile && <hr className="horizontal-line"/>}
    </div>
    <Slider {...settings}>
      {reviews.map((review: IReviews, index: number) =>
      <div key={index}>
        <Card>
          <CardBody>
            <div className='d-flex mt-2 mb-4'>
              <div className="user-avatar user-avatar-sm">
                <div className="user-avatar-noimg bg-primary bg-soft text-primary">
                  <span className="user-avatar-initials">{getInitials(review.name)}</span>
                </div>
              </div>
              <div className="d-flex flex-column ms-2">
                <div className='mb-0'>{review.name}</div>
                <StarRatings
                    rating={review.stars}
                    starRatedColor="#f1b44c"
                    starEmptyColor="#74788d"
                    numberOfStars={5}
                    name="rating"
                    starDimension="14px"
                    starSpacing="1px"
                  />
              </div>
            </div>
            <div className='review-comment'>{review.comment}</div>
          </CardBody>
        </Card>
      </div>)}
    </Slider>
</section>
}

export default ReviewsSection;